import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';

const NorthDakota = () => {
  const [showAllCities, setShowAllCities] = useState(false);

  useEffect(() => {
    // Set document title and meta tags
    document.title = 'We Buy Valves North Dakota | Industrial Equipment Buyers North Dakota';
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Professional industrial equipment buyers throughout North Dakota. We buy valves, control systems, and instrumentation from Bismarck, Williston, and all North Dakota facilities at above scrap rates.');
    }
    
    // Set meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', 'north dakota valve buyers, we buy valves north dakota, industrial equipment buyers north dakota, bakken valve buyers');
    
    // Set canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://valvesalessupply.com/north-dakota');
    
    // Set Open Graph tags
    const ogTags = [
      { property: 'og:title', content: 'We Buy Valves North Dakota | Industrial Equipment Buyers North Dakota' },
      { property: 'og:description', content: 'Professional industrial equipment buyers throughout North Dakota. We buy valves, control systems, and instrumentation from Bismarck, Williston, and all North Dakota facilities.' },
      { property: 'og:url', content: 'https://valvesalessupply.com/north-dakota' },
      { property: 'og:type', content: 'website' }
    ];
    
    ogTags.forEach(tag => {
      let ogTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!ogTag) {
        ogTag = document.createElement('meta');
        ogTag.setAttribute('property', tag.property);
        document.head.appendChild(ogTag);
      }
      ogTag.setAttribute('content', tag.content);
    });
    
    // Set geo location tags
    let geoPosition = document.querySelector('meta[name="geo.position"]');
    if (!geoPosition) {
      geoPosition = document.createElement('meta');
      geoPosition.setAttribute('name', 'geo.position');
      document.head.appendChild(geoPosition);
    }
    geoPosition.setAttribute('content', '47.5515;-101.0020');
    
    let geoRegion = document.querySelector('meta[name="geo.region"]');
    if (!geoRegion) {
      geoRegion = document.createElement('meta');
      geoRegion.setAttribute('name', 'geo.region');
      document.head.appendChild(geoRegion);
    }
    geoRegion.setAttribute('content', 'US-ND');
    
    let geoPlacename = document.querySelector('meta[name="geo.placename"]');
    if (!geoPlacename) {
      geoPlacename = document.createElement('meta');
      geoPlacename.setAttribute('name', 'geo.placename');
      document.head.appendChild(geoPlacename);
    }
    geoPlacename.setAttribute('content', 'North Dakota, United States');
    
    // Set last-modified
    let lastModified = document.querySelector('meta[http-equiv="last-modified"]');
    if (!lastModified) {
      lastModified = document.createElement('meta');
      lastModified.setAttribute('http-equiv', 'last-modified');
      document.head.appendChild(lastModified);
    }
    lastModified.setAttribute('content', new Date().toISOString());

    // Add Schema.org structured data
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://valvesalessupply.com/north-dakota/#webpage",
          "url": "https://valvesalessupply.com/north-dakota",
          "name": "North Dakota Industrial Equipment Buyers - ValveSalesSupply",
          "description": "Professional industrial equipment purchasing services throughout North Dakota. Serving Bismarck, Williston, and Bakken oil field operations with above scrap market rates.",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://valvesalessupply.com"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Service Areas",
                "item": "https://valvesalessupply.com/service-areas"
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": "North Dakota",
                "item": "https://valvesalessupply.com/north-dakota"
              }
            ]
          }
        },
        {
          "@type": "Place",
          "@id": "https://valvesalessupply.com/north-dakota/#place",
          "name": "North Dakota",
          "address": {
            "@type": "PostalAddress",
            "addressRegion": "ND",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 47.5515,
            "longitude": -101.0020
          }
        },
        {
          "@type": "LocalBusiness",
          "name": "ValveSalesSupply North Dakota Operations",
          "address": {
            "@type": "PostalAddress",
            "addressRegion": "ND",
            "addressCountry": "US"
          },
          "telephone": "+1-214-854-5638",
          "serviceArea": {
            "@type": "State",
            "name": "North Dakota",
            "addressRegion": "ND"
          },
          "description": "Professional industrial equipment purchasing services throughout North Dakota, serving Bakken oil field operations, refineries, and industrial facilities in Bismarck, Williston, and surrounding areas."
        },
        {
          "@type": "ItemList",
          "name": "North Dakota Cities We Serve",
          "numberOfItems": 2,
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "item": {
                "@type": "Place",
                "name": "Bismarck",
                "url": "https://valvesalessupply.com/cities/bismarck"
              }
            },
            {
              "@type": "ListItem",
              "position": 2,
              "item": {
                "@type": "Place",
                "name": "Williston",
                "url": "https://valvesalessupply.com/cities/williston"
              }
            }
          ]
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "Do you buy valves in North Dakota?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, we buy surplus valves throughout North Dakota including Bismarck, Williston, and all Bakken oil field operations. We purchase control valves, gate valves, ball valves, and complete instrumentation systems at above scrap rates."
              }
            },
            {
              "@type": "Question",
              "name": "What areas of North Dakota do you serve?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We serve all major North Dakota industrial centers including Bismarck, Williston, Mandan, Dickinson, and throughout the Bakken oil field region with 6-12 hour response times."
              }
            },
            {
              "@type": "Question",
              "name": "What types of equipment do you buy in North Dakota?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We purchase oil and gas processing equipment, control valves, compression equipment, wellhead equipment, pipeline valves, instrumentation, and emergency shutdown systems from North Dakota facilities."
              }
            },
            {
              "@type": "Question",
              "name": "How quickly can you respond in North Dakota?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We provide 6-10 hour response times throughout North Dakota, with specialized knowledge of Bakken operations and harsh weather conditions."
              }
            }
          ]
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const northDakotaFacilities = [
    { name: 'Mandan', facilities: '2+ Refineries', response: '6-8 Hours' },
    { name: 'Dickinson', facilities: 'Processing Plants', response: '8-10 Hours' },
    { name: 'Williston', facilities: 'Gas Processing', response: '8-10 Hours' },
    { name: 'Bismarck', facilities: 'Industrial Plants', response: '6-8 Hours' }
  ];

  const northDakotaCities = [
    'Beulah', 'Bismarck', 'Bottineau', 'Bowman', 'Carrington', 'Casselton', 'Cavalier', 'Devils Lake',
    'Dickinson', 'Ellendale', 'Fargo', 'Grafton', 'Grand Forks', 'Harvey', 'Hazen', 'Hillsboro',
    'Jamestown', 'Langdon', 'Lincoln', 'Lisbon', 'Mandan', 'Mayville', 'Minot', 'New Town',
    'Oakes', 'Park River', 'Rugby', 'Stanley', 'Tioga', 'Valley City', 'Wahpeton', 'Washburn',
    'Watford City', 'West Fargo', 'Williston', 'Wishek'
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/73f06297494f0488b004ab16933d4bd6.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#1B3A5F]/90 to-[#1B3A5F]/70"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-white">
          <div className="max-w-4xl">
            <h1 className="text-5xl font-bold mb-6">We Buy Valves North Dakota</h1>
            <p className="text-xl text-gray-200 mb-8 leading-relaxed">
              Professional surplus equipment buyer serving North Dakota oil refineries and gas processing facilities. 
              We purchase valves, control systems, and instrumentation from the Bakken region, Mandan, Dickinson, 
              and throughout North Dakota at above scrap rates.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="tel:(214) 854-5638"
                className="bg-white text-[#1B3A5F] px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                CALL (214) 854-5638
              </a>
              <Link
                to="/contact"
                className="border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-[#1B3A5F] transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                GET NORTH DAKOTA QUOTE
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* North Dakota Market */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-[#1B3A5F] text-4xl font-bold mb-6">INDUSTRIAL EQUIPMENT BUYER NORTH DAKOTA</h2>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                North Dakota's Bakken oil boom has created significant industrial infrastructure requiring professional 
                <strong className="text-[#1B3A5F]"> surplus equipment removal</strong> services during facility 
                maintenance and upgrades.
              </p>
              <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                We provide <strong className="text-[#1B3A5F]">oilfield equipment buyer</strong> services throughout 
                North Dakota, specializing in control valves, processing equipment, and instrumentation from 
                refineries and gas processing facilities.
              </p>
              
              <div className="grid md:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">8+</div>
                  <div className="text-gray-600">ND Facilities</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">6-10 Hrs</div>
                  <div className="text-gray-600">Response Time</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">12 Years</div>
                  <div className="text-gray-600">Bakken Experience</div>
                </div>
              </div>
            </div>
            
            <div className="bg-[#F5F7FA] rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">NORTH DAKOTA SERVICE AREAS</h3>
              <div className="space-y-4">
                {northDakotaFacilities.map((facility, index) => (
                  <div key={index} className="flex justify-between items-center bg-white rounded-lg p-4">
                    <div>
                      <h4 className="text-[#1B3A5F] font-bold text-lg">{facility.name}</h4>
                      <p className="text-gray-600 text-sm">{facility.facilities}</p>
                    </div>
                    <div className="text-right">
                      <div className="text-[#1B3A5F] font-semibold">Response:</div>
                      <div className="text-gray-600 text-sm">{facility.response}</div>
                    </div>
                  </div>
                ))}
              </div>
              
              <div className="mt-6 p-4 bg-[#1B3A5F]/10 rounded-lg">
                <h4 className="text-[#1B3A5F] font-bold mb-2">Bakken Region Expertise</h4>
                <p className="text-gray-600 text-sm">Specialized knowledge of North Dakota oil and gas equipment</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Equipment and Services */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">SURPLUS EQUIPMENT REMOVAL NORTH DAKOTA</h2>
            <p className="text-gray-600 text-xl">Professional equipment purchasing from North Dakota oil and gas facilities</p>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-12">
            <div className="bg-white rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">Bakken Equipment We Buy</h3>
              <div className="space-y-4">
                {[
                  'Oil and Gas Processing Equipment',
                  'Control Valves and Safety Systems',
                  'Compression Equipment',
                  'Separation and Storage Equipment',
                  'Pipeline Valves and Fittings',
                  'Wellhead Equipment',
                  'Instrumentation and Controls',
                  'Emergency Shutdown Systems'
                ].map((item, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">{item}</span>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="bg-white rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">North Dakota Advantages</h3>
              <div className="space-y-4">
                {[
                  'Bakken region expertise and experience',
                  'Understanding of harsh weather operations',
                  'Above scrap rates for functional equipment',
                  'Professional documentation and compliance',
                  'Coordinated removal during shutdowns',
                  'Emergency response capabilities',
                  '12+ years North Dakota experience',
                  'Licensed for oil and gas operations'
                ].map((benefit, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">{benefit}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* North Dakota Cities We Serve */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">NORTH DAKOTA CITIES WE SERVE</h2>
            <p className="text-gray-600 text-xl">Professional valve buying services across North Dakota's major industrial centers</p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-lg p-8 shadow-sm hover:shadow-md transition-shadow">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-teal-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-building-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-3">
                    <a href="/bismarck" className="hover:text-teal-600 transition-colors">
                      Bismarck Valve Buyers
                    </a>
                  </h3>
                  <p className="text-gray-600 mb-4">
                    As North Dakota's capital, Bismarck serves as a hub for energy infrastructure and industrial operations. We buy surplus valves from refineries, power plants, and manufacturing facilities throughout the capital region. Our team provides fast evaluations and competitive pricing for all valve types.
                  </p>
                  <a href="/bismarck" className="text-teal-600 hover:text-teal-700 font-medium inline-flex items-center gap-2">
                    Learn More <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg p-8 shadow-sm hover:shadow-md transition-shadow">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-teal-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-oil-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-3">
                    <a href="/williston" className="hover:text-teal-600 transition-colors">
                      Williston Valve Buyers
                    </a>
                  </h3>
                  <p className="text-gray-600 mb-4">
                    Located in the heart of the Bakken oil field, Williston is a major center for oil and gas operations. We purchase surplus valves from drilling operations, processing facilities, and pipeline infrastructure. Get top dollar for your unused valve inventory with our streamlined buying process.
                  </p>
                  <a href="/williston" className="text-teal-600 hover:text-teal-700 font-medium inline-flex items-center gap-2">
                    Learn More <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* We Buy Surplus Valves North Dakota */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">WE BUY SURPLUS VALVES NORTH DAKOTA</h2>
            <p className="text-gray-600 text-xl">North Dakota's premier surplus valve buyers - serving the Bakken region</p>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div 
              className="rounded-3xl overflow-hidden shadow-lg bg-cover bg-center h-96"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=North%20Dakota%20Bakken%20oil%20field%20surplus%20valves%20control%20valves%20gate%20valves%20pipeline%20valves%20wellhead%20equipment%20professional%20valve%20warehouse%20organized%20inventory%20prairie%20landscape%20winter&width=600&height=400&seq=northdakota-surplus-valves-012&orientation=landscape')`
              }}
            >
              <div className="bg-gradient-to-t from-[#1B3A5F]/80 to-transparent h-full flex items-end p-8">
                <div className="text-white">
                  <h3 className="text-2xl font-bold mb-2">Bakken Grade Valves</h3>
                  <p>Rugged surplus valves built for harsh North Dakota conditions</p>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-[#1B3A5F] text-3xl font-bold mb-6">NORTH DAKOTA SURPLUS VALVE SPECIALISTS</h3>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                As <strong className="text-[#1B3A5F]">North Dakota's leading surplus valve buyers</strong>, 
                we specialize in purchasing quality used valves from Bakken shale operations, gas processing 
                plants, and refineries throughout the state. Our expertise in harsh winter conditions and 
                oilfield operations ensures proper equipment assessment and maximum value recovery.
              </p>
              
              <div className="space-y-4 mb-8">
                {[
                  {
                    type: 'Bakken Oilfield Valves',
                    description: 'Production valves, wellhead equipment from North Dakota operations',
                    icon: 'ri-oil-line'
                  },
                  {
                    type: 'Gas Processing Valves',
                    description: 'Control valves from Williston Basin gas processing facilities',
                    icon: 'ri-fire-line'
                  },
                  {
                    type: 'Pipeline Infrastructure',
                    description: 'Gate valves, ball valves from interstate pipeline systems',
                    icon: 'ri-road-map-line'
                  },
                  {
                    type: 'Winter-Grade Equipment',
                    description: 'Cold weather valves rated for extreme North Dakota conditions',
                    icon: 'ri-snowflake-line'
                  }
                ].map((valve, index) => (
                  <div key={index} className="flex items-start">
                    <div className="w-12 h-12 bg-[#1B3A5F] rounded-lg flex items-center justify-center mr-4 mt-1">
                      <i className={`${valve.icon} text-white text-xl`}></i>
                    </div>
                    <div>
                      <h4 className="text-[#1B3A5F] font-bold text-lg mb-2">{valve.type}</h4>
                      <p className="text-gray-600">{valve.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              
              <div className="bg-[#F5F7FA] rounded-lg p-6">
                <h4 className="text-[#1B3A5F] font-bold mb-3">North Dakota Winter Readiness:</h4>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="flex items-center">
                    <i className="ri-snowflake-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">Cold weather operations</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-time-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">6-10 hour response</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-truck-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">Weather-ready logistics</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-award-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">12+ years Bakken experience</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 bg-[#1B3A5F]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-white text-4xl font-bold mb-4">SELL OILFIELD EQUIPMENT NORTH DAKOTA</h2>
            <p className="text-gray-200 text-xl">Professional equipment buyer serving North Dakota Bakken region</p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="bg-white rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">NORTH DAKOTA CONTACT</h3>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-center">
                  <i className="ri-phone-line text-[#1B3A5F] text-xl mr-4"></i>
                  <div>
                    <div className="font-bold text-lg">(214) 854-5638</div>
                    <div className="text-gray-600">North Dakota Direct Line</div>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <i className="ri-mail-line text-[#1B3A5F] text-xl mr-4"></i>
                  <div>
                    <div className="font-bold">valvesalessupply@gmail.com</div>
                    <div className="text-gray-600">Bakken Equipment Assessments</div>
                  </div>
                </div>
              </div>
              
              <Link
                to="/contact"
                className="w-full bg-[#1B3A5F] text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-[#1B3A5F]/90 transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                GET NORTH DAKOTA QUOTE
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
            
            <div className="text-white">
              <h3 className="text-3xl font-bold mb-6">WHY CHOOSE US IN NORTH DAKOTA</h3>
              <div className="space-y-4">
                {[
                  'Bakken region expertise since 2012',
                  'Above scrap rates for quality equipment',
                  'Fast response across North Dakota',
                  'Weather-resistant operations',
                  'Complete regulatory compliance',
                  'Emergency equipment removal'
                ].map((benefit, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-white text-xl mr-4"></i>
                    <span className="text-lg">{benefit}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* North Dakota Cities Dropdown - Above FAQ */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">WE BUY SURPLUS VALVES IN ALL NORTH DAKOTA CITIES</h2>
            <p className="text-gray-600 text-xl mb-8">Professional valve buying services across North Dakota - Click to view all cities</p>
          </div>

          <div className="bg-[#F5F7FA] rounded-3xl p-8 mb-8">
            <div className="grid md:grid-cols-3 gap-6 mb-6">
              <div className="text-center">
                <div className="text-[#1B3A5F] text-3xl font-bold mb-2">35+</div>
                <div className="text-gray-600">North Dakota Cities Served</div>
              </div>
              <div className="text-center">
                <div className="text-[#1B3A5F] text-3xl font-bold mb-2">6-12 Hours</div>
                <div className="text-gray-600">Average Response Time</div>
              </div>
              <div className="text-center">
                <div className="text-[#1B3A5F] text-3xl font-bold mb-2">Bakken Ready</div>
                <div className="text-gray-600">Oil Field Equipment Specialists</div>
              </div>
            </div>
          </div>

          <button
            onClick={() => setShowAllCities(!showAllCities)}
            className="w-full bg-[#1B3A5F] text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-[#1B3A5F]/90 transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap mb-8"
          >
            {showAllCities ? 'HIDE NORTH DAKOTA CITIES' : 'VIEW ALL NORTH DAKOTA CITIES'}
            <i className={`${showAllCities ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} ml-2 text-2xl`}></i>
          </button>

          {showAllCities && (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 animate-fadeIn">
              {northDakotaCities.map((city, index) => (
                <div
                  key={index}
                  className="bg-white rounded-lg p-4 border-2 border-[#F5F7FA] hover:border-[#1B3A5F] hover:shadow-lg transition-all duration-300 cursor-pointer"
                >
                  <div className="flex items-center justify-between">
                    <div>
                      <h3 className="text-[#1B3A5F] font-bold text-lg mb-1">{city}</h3>
                      <p className="text-gray-600 text-sm">We Buy Valves {city} ND</p>
                    </div>
                    <i className="ri-map-pin-line text-[#1B3A5F] text-xl"></i>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ItemList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "item": {
                "@type": "LocalBusiness",
                "@id": "https://valvebuyers.com/bismarck",
                "name": "Valve Buyers - Bismarck",
                "url": "https://valvebuyers.com/bismarck"
              }
            },
            {
              "@type": "ListItem",
              "position": 2,
              "item": {
                "@type": "LocalBusiness",
                "@id": "https://valvebuyers.com/williston",
                "name": "Valve Buyers - Williston",
                "url": "https://valvebuyers.com/williston"
              }
            }
          ]
        })}
      </script>

      <Footer />
    </div>
  );
};

export default NorthDakota;
